
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categoria-teste/[...slug]",
      function () {
        return require("private-next-pages/categoria-teste/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/categoria-teste/[...slug]"])
      });
    }
  